import React from "react";
import { Progress } from "antd";

interface ProgressBarProps {
  percent: number;
  size?: "small" | "default";
  className?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ percent, size = "small", className }) => {

  return (
    <Progress
      percent={percent}
      size={size}
      showInfo={false}
      className={className}
    />
  );
};
